import TvanHandleApi from 'api/TvanHandleApi'
import ModalConfirm from 'general/components/Modal/ModalConfirm'
import ToastHelper from 'general/helpers/ToastHelper'
import { memo, useCallback, useEffect, useRef, useState } from 'react'
import { useFormik } from 'formik'
import DraggableModal from 'general/components/Modal/DragableModal/DraggableModal'
import { Typography } from 'antd'
import CustomAntInput from 'general/components/Forms/CustomAntInput/CustomAntInput'
import * as Yup from 'yup'
import { REGEX_TVAN_MESSAGE } from 'general/constants/AppRegex'
import CustomLabel from 'general/components/CustomLabel'
import CustomSelect from 'general/components/CustomSelect'
import SelectOptions from 'general/constants/SelectOptions'
import { FormLabel } from 'react-bootstrap'
const ModalCompanyIsDataLog = ({
  modalsState,
  setModalsState,
  refetchListInvoice,
}) => {
  const [dataConfix, setDataConfix] = useState({
    isDataLog: modalsState?.value?.isDataLog,
    companyId: modalsState?.value?.companyId,
  })

  useEffect(() => {
    console.log('modalsState', modalsState)
    if (modalsState?.show) {
      setDataConfix({
        isDataLog: modalsState?.value?.isDataLog,
        companyId: modalsState?.value?.companyId,
      })
    }
  }, [modalsState?.show])

  const updateConfigLogbomCompany = async (dataConfix) => {
    // Your logic to move to send invoice goes here
    // For example, you can call an API endpoint to move to send invoice
    // await sendInvoiceToHandler(payload)
    try {
      const { result, message } = await TvanHandleApi.updateConfigCompany({
        ...dataConfix,
        type: 'viewLogBom',
      })
      if (result?.result === 'success') {
        ToastHelper.showSuccess('Cấu hình thành công')
        refetchListInvoice()
      } else {
        ToastHelper.error('Lỗi nội bộ máy chủ')
      }
    } catch (error) {
      console.error(
        'Occured error at moveToSendErrorHandler function: ' + error,
      )
    }
  }
  console.log('modalsState', modalsState)

  const updateMessageForm = useFormik({
    initialValues: {
      messageId: '',
    },
    validationSchema: Yup.object({
      messageId: Yup.string()
        .matches(REGEX_TVAN_MESSAGE, 'Mã thông điệp không hợp lệ, hãy thử lại!')
        .required('Mã thông điệp không được để trống'),
    }),
    onSubmit: async (values) => {
      // await updateMessage({
      //   invoiceId: tvanState.activeRow?.invoiceId,
      //   messageId: values.messageId.trim(),
      // })
    },
  })
  const thisModalRef = useRef()

  return (
    <>
      <ModalConfirm
        header="Cấu hình hiển thị danh sách log bơm"
        content={
          <>
            <p>
              <b>Null</b>: khôi phục lại trang thái ban đầu, khi khách hàng có
              hóa đơn đầu tiên phía ATC {`->`} tự động chuyển thành <b>2</b>
            </p>
            <p>
              <b>1</b>: hiển thị sách log bơm trên menu hóa đơn
            </p>
            <p>
              <b>2</b>: hiển thị log bơm trên menu hóa đơn
            </p>
            <p>
              <b>3</b>: hiển thị sách log bơm trên menu hóa đơn và không tự động
              chuyển lại
            </p>

            <div className="flex-row">
              <div>
                <FormLabel fontWeight="600">Giá trị hiển thị</FormLabel>
              </div>
              <div>
                <CustomSelect
                  selectOptions={SelectOptions.isDataLogs}
                  currentValue={dataConfix?.isDataLog}
                  defaultValue={dataConfix?.isDataLog}
                  onChange={(selectedOption) => {
                    setDataConfix({
                      ...dataConfix,
                      isDataLog: selectedOption?.value,
                    })
                  }}
                  haveMenuParentRef={false}
                  width="100%"
                />
              </div>
            </div>
          </>
        }
        show={modalsState.show}
        setShow={(status) => setModalsState({ ...modalsState, show: status })}
        handleConfirm={(e) => {
          updateConfigLogbomCompany(dataConfix)
          // e.preventDefault()
          // moveToSendErrorHandler({ invoiceId: tvanState.activeRow?.invoiceId })
          // setModalsState({ key: 'moveStatusModal', value: false })
        }}
      />
    </>
  )
}
export default memo(ModalCompanyIsDataLog)
